import React from "react";
//#region types
import { EntityCardContentProps } from "models/propTypes/pageLayoutPropTypes";
import { EntityCardLayoutConstants, HTMLConstants } from "utils/constants";
//#endregion
//#region components
import { Grid, Portal, Grow } from "@mui/material";
import useHideParentWhenNoChildren from "../useHideParentWhenNoChildren";
import FloatingMessageProvider from "../messages/floatingMessageProvider";
import LoadingWithLogo from "../loading/loadingWithLogo";
import EntityCardContentInfoViewer from "./entityCard/infoViewerPortal";
//#endregion
import cssExports from "theme/styles/main.module.scss";

const EntityCardContent: React.FC<EntityCardContentProps> = (props) => {
  const topCardMount = document.getElementById(EntityCardLayoutConstants.TopTodoCardId);
  const betweenCardsMount = document.getElementById(EntityCardLayoutConstants.BetweenCardsContentId);
  const mainSectionMount = document.getElementById(EntityCardLayoutConstants.MainCardContentId);
  const childrenMount = document.getElementById(EntityCardLayoutConstants.OtherContentId);
  const footerMount = document.getElementById(EntityCardLayoutConstants.FooterId);

  //#region showHide static messages container if there are messages
  useHideParentWhenNoChildren(`#${HTMLConstants.MessagesId}`);
  useHideParentWhenNoChildren(`#${EntityCardLayoutConstants.BetweenCardsContentId}`);
  useHideParentWhenNoChildren(`#${EntityCardLayoutConstants.MainCardContentId}`);
  //#endregion

  return (
    <FloatingMessageProvider
      customRootId={HTMLConstants.MessagesId}
      className={cssExports.snackbarContainerStatic}
      TransitionComponent={Grow}
    >
      {props.loading && (
        <div className={cssExports.cardLoadingContainer}>
          <LoadingWithLogo />
        </div>
      )}
      <Portal container={topCardMount}>{props.topTodoCard}</Portal>
      <Portal container={betweenCardsMount}>{props.betweenCardsBanner}</Portal>
      <Portal container={mainSectionMount}>{props.todoMainSection}</Portal>
      <Portal container={childrenMount}>
        {props.children ? (
          Array.isArray(props.children) ? (
            props.children.map((childElem, index) => (
              <Grid container item key={index}>
                {childElem}
              </Grid>
            ))
          ) : (
            <Grid container item>
              {props.children}
            </Grid>
          )
        ) : (
          <></>
        )}
      </Portal>

      <Portal container={footerMount}>
        <Grid container className={cssExports.fadeInFooter}>
          {props.footer}
        </Grid>
      </Portal>
      <EntityCardContentInfoViewer infoViewer={props.infoViewer} />
    </FloatingMessageProvider>
  );
};

export default EntityCardContent;
